import { type QueryHookOptions, useQuery } from "@apollo/client";
import { PlatformCustomCoverQuery } from "../graphql/queries";
import type { PlatformCustomCoverQueryType } from "@/types/graphql/partner.generated";

export const usePlatformCustomCoverQuery = (
  options?: QueryHookOptions<PlatformCustomCoverQueryType>
) => {
  return useQuery<PlatformCustomCoverQueryType>(
    PlatformCustomCoverQuery,
    options
  );
};
